module.exports = __webpack_public_path__ + "img/info-overview.b36f1c03.svg";